<template>
<el-dialog title="退回" :append-to-body="true" :close-on-click-modal="false" width="60%" :visible.sync="viewData.visible">
    <el-form :model="dataForm" ref="dataForm" @keyup.enter.native="dataFormSubmit()" size="small" label-width="0px" class="org-dialog-form">
        <div class="des_box">
            <el-descriptions class="margin-top" :column="2" size="small" border style="margin-bottom: 15px;">
                <el-descriptions-item label="驳回原因:" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item style="margin-bottom: 0;" prop="rejectReason">
                        <el-input type="textarea" v-model="dataForm.rejectReason" placeholder="驳回原因" size="small"></el-input>
                    </el-form-item>
                </el-descriptions-item>
            </el-descriptions>
        </div>

        <el-row :gutter="40">
            <el-col :span="24" style="text-align:right;">
                <el-button size="small" @click="viewData.visible = false">
                    取消
                </el-button>
                <el-button size="small" plain type="primary" @click="rejectConfirm()">
                    确认
                </el-button>
            </el-col>
        </el-row>
    </el-form>
</el-dialog>
</template>

<script>
import {
    DIALOG_CLOSED_TYPE,
} from "@/utils/const";
export default {
    data() {
        return {
            viewData: {
                visible: false,
                width: ''
            },
            viewFlag: '',
            dataForm: {
                rejectReason: '',
            },
            dataRule: {
                // projectManagerId: [{
                //     required: true,
                //     message: '项目负责人名称不能为空',
                //     // trigger: 'blur'
                // }],
                // code: [{
                //     required: true,
                //     message: '组织代码不能为空',
                //     trigger: 'blur'
                // }],
                // tenantName: [{
                //     required: true,
                //     message: '请先在页面顶部导航栏选择租户',
                //     trigger: 'blur'
                // }]
            }
        }
    },
    mounted() {},
    methods: {
        open() {
            this.viewData.visible = true
            this.dataForm.rejectReason = ''
        },
        onClosed(params) {
            console.log(params)
            return;
        },
        // 筛选按钮弹框取消
        cancel() {
            this.close();
        },
        close(option = DIALOG_CLOSED_TYPE.CLOSE) {
            if (!this.viewData.visible) {
                return;
            }
            this.onClosed({
                option,
                sender: this,
                data: this.dataForm.rejectReason,
            });
            this.viewData.visible = false;
        },
        rejectConfirm() {
            // 退回原因
            this.close(DIALOG_CLOSED_TYPE.CONFIRM);
        },
        getStyle() {
            return 'width: 130px; text-align: right'
        },
        getStyle2() {
            return 'width: 425.5px;'
        }
    },
}
</script>